import { useState } from 'react';
import { authStaff } from "../../../utils/constants";
import { uploadFileRequest } from "../../../Requests/getRequests";
import { useDispatch, useSelector } from "react-redux";
import { selectAccessToken } from "../../../slices/staffSlice";
import { show } from '../../../slices/toastSlice';
import { useNavigate } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { UploadCircle01Icon } from '@hugeicons/core-free-icons';

function FileUpload({ loan }) {

    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [fileType, setFileType] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [process, setProcess] = useState(false);

    const handleFileChange = (e) => setSelectedFile(e.target.files[0]);

    const uploadRequest = async (e) => {
        e.preventDefault();
        setProcess(true);

        if (fileType === "") {
            setProcess(false);
            dispatch(show({ type: "error", state: true, message: "Please select a file type" }));
            return;
        }

        let formData = new FormData();
        formData.append(fileType, selectedFile);
        formData.append('_id', loan?._id);
        formData.append('type', loan?.type.toLowerCase());

        let res = await uploadFileRequest(`/loans/staff/upload-docs`, {
            ...authStaff(accessToken),
            "Content-Type": "multipart/form-data"
        }, formData);

        if (res?.code === 401) {
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
            return;
        }
        if (res?.err) {
            dispatch(show({ type: "error", state: true, message: res?.err }));
        } else {
            dispatch(show({ type: "success", state: true, message: res?.message }));
            setTimeout(() => window.location.reload(), 1500);
        }
        setProcess(false);
    };

    return (
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
            <div className="px-5 py-3.5 border-b border-gray-100">
                <h4 className="text-sm font-semibold text-gray-700">File Uploads</h4>
            </div>
            <div className="p-5">
                <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-end">
                    <div className="flex-1">
                        <label className="block text-xs font-medium text-gray-500 mb-1.5">File type</label>
                        <div className="relative">
                            <select
                                className="w-full appearance-none text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 text-gray-700 pr-8"
                                onChange={(e) => setFileType(e.target.value)}
                            >
                                <option value="" hidden>— select an option —</option>
                                {loan?.state !== "approved" ? (
                                    <>
                                    <option value="incDoc">Incorporation Document</option>
                                    <option value="solePropId">Sole Proprietorship ID</option>
                                    <option value="bankDoc">Bank Document</option>
                                    <option value="momo">Mobile Money</option>
                                    <option value="id">ID Card</option>
                                    <option value="residence">Proof of Residence</option>
                                    <option value="groupAgree">Group Agreement</option>
                                    <option value="other">Other Document</option>
                                    </>
                                ) : (
                                    <>
                                    <option value="facility-letter-signed">Facility Letter (signed)</option>
                                    <option value="standOrder">Standing Order</option>
                                    <option value="other">Other</option>
                                    </>
                                )}
                            </select>
                        </div>
                    </div>

                    <div className="flex-1">
                        <label className="block text-xs font-medium text-gray-500 mb-1.5">Select file</label>
                        <input
                            type="file"
                            className="w-full text-sm text-gray-500 file:mr-3 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-xs file:font-medium file:bg-gray-100 file:text-gray-700 hover:file:bg-gray-200 file:cursor-pointer border border-gray-200 rounded-lg py-1.5 px-2 focus:outline-none"
                            onChange={handleFileChange}
                        />
                    </div>

                    <button
                        type="button"
                        onClick={uploadRequest}
                        disabled={process || !selectedFile}
                        className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed shrink-0"
                        style={{ backgroundColor: '#1e3a6e' }}
                    >
                        <HugeiconsIcon icon={UploadCircle01Icon} size={16} />
                        {process ? 'Uploading…' : 'Upload'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default FileUpload;
